<!-- ModalComponent.vue -->

<template>
  <div class="modal" v-if="showModal">
    <div class="modal-content">
      <p>{{ message }}</p>
      <div class="modal-buttons">
        <button @click="handleOk">Ok</button>
        <button @click="handleCancel">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fvlDialogBox",
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleOk() {
      // Emit an event or perform an action when Ok button is clicked
      this.$emit("ok");
    },
    handleCancel() {
      // Emit an event or perform an action when Cancel button is clicked
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
/* Add your modal styling here */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
}

.modal-buttons {
  margin-top: 10px;
  text-align: right;
}

button {
  margin-left: 10px;
}
</style>
